import React from 'react';

import Dashboard from '../containers/dashboard';
import { DemoAccountContextProvider } from '../contexts/DemoAccountContextProvider';

const DashboardAppClient = ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <Dashboard {...props} />
  </DemoAccountContextProvider>
);

export default DashboardAppClient;
